import { AppBar, Box, Tab, Tabs, useTheme } from "@mui/material"
import React, { useEffect, useState } from "react"
import { useLocation, useParams } from "react-router-dom"

import EditSponsor from "./EditSponsor"
import ServiceForm from "./ServiceForm"
import SwipeableViews from "react-swipeable-views"
import { featureBusinessConfigData } from "./FeaturedBusinesses"
import { getFeaturedBusinessDocPath } from "./featuredBusinessesPaths"
import { getData } from "./core/CreateEditOptions/getData"
import { AddEditComponent } from "../GenericList"

function TabPanel(props: { [x: string]: any; children: any; value: any; index: any }) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  }
}

const FeaturedBusinessTabs = ({ onSuccess }: any) => {
  const { id } = useParams()
  const { state } = useLocation()
  const [data, setData] = useState()
  const [value, setValue] = useState(0)
  const theme = useTheme()

  const handleChange = (event: any, newValue: React.SetStateAction<number>) => {
    setValue(newValue)
  }

  const handleChangeIndex = (index: React.SetStateAction<number>) => {
    setValue(index)
  }
  function reload() {
    if (!id) return
    getData({ path: getFeaturedBusinessDocPath(id), setData })
  }
  useEffect(() => {
    if (state?.id) {
      setData(state)
    } else {
      reload()
    }
  }, [id, state])

  return (
    <Box sx={{ bgcolor: "background.paper", width: "80vw" }}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="Featured Business Detail" {...a11yProps(0)} />
          <Tab label="Featured Business Services" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          {/* <EditSponsor featureBusiness={true} /> */}
              <AddEditComponent
                          Service={featureBusinessConfigData}
                          mainId={id}
                          format={undefined}
                          data={data || (featureBusinessConfigData as any).defaultAddData || {}}
                          onAdded={() => {
                            reload && reload()
                            onSuccess && onSuccess()
                          }}
                        />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <ServiceForm featureBusiness={true} />
        </TabPanel>
      </SwipeableViews>
    </Box>
  )
}
export default FeaturedBusinessTabs
